import React from 'react';
import { Field, FieldArray, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import Modal from '../../../SharedComponents/Modal';
import PlusCircle from '../../../SharedComponents/Svg/PlusCircle';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Loading from '../../../SharedComponents/Loading';
import { useTranslation } from 'react-i18next';
import LanguageList from '../../../SharedComponents/LanguageList';
import { ChangeRequestStatus, getLanguages } from '../../Requests/ApRequests';
import { useHistory, useParams } from 'react-router';
import { dir } from '../../../utils/localisation';
import axios from 'axios';
// import { sendMessage } from '../../utils/sendMessage';

export default function AddUserMemberShipId(props) {
  const [isOpen, setIsOpen] = useState(false);
  const { id } = props.id ? props : 1;
  const { typeId, submitionUserId } = props;
  const { t, i18n } = useTranslation();
  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-green-500 space-x-1 ${
          i18n.language === 'en' ? '' : 'space-x-reverse'
        } text-sm font-bold text-white flex items-center hover:bg-green-600 shadow  px-4 py-2 rounded transition duration-300 ease-in-out`}
      >
        {' '}
        <span>اضافة رقم عضوية</span>
      </button>

      {isOpen && (
        <ModalContainer
          submitionUserId={submitionUserId}
          id={id}
          typeId={typeId}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
}

const ModalContainer = (props) => {
  const { isOpen, setIsOpen, submitionUserId } = props;
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const userData = localStorage.getItem('token');
  const userId = JSON.parse(userData).userId;

  const queryClient = useQueryClient();

  const addNotificationMutation = useMutation(addNotification, {
    onSuccess: async (data) => {
      queryClient.invalidateQueries(['getSubmittionsById']);
      queryClient.invalidateQueries(['GetByRepliesForSubmittion']);
      setIsOpen(false);
    },
  });
  // Mutate Data to Create New Page
  const mutation = useMutation(editUserMembership, {
    onSuccess: async (data, variables) => {
      if (data.isDone) {
        console.log('variables', variables);
        addNotificationMutation.mutate({
          userId: variables.id,
          message: `تم اضافة رقم عضوية  - ${variables.memberShip}`,
          notificationStatus: 1,
        });
      }
    },
  });

  const fetchUserData = async (key) => {
    const { data } = await axios.post(`/UserAccount/GetUser?id=${submitionUserId}`);
    return data;
  };

  const { status, data, error, refetch, isLoading, isError } = useQuery(['UserData'], fetchUserData);
  if (isLoading) return '';
  if (isError) return '';
  console.log('data', data);
  const onSubmit = (e) => {
    try {
      mutation.mutate({
        id: e.id,
        userName: e.userName,
        phone: 'string',
        email: e.email,
        role: 1027,
        fullName: 'string',
        meta: 'string',
        userStatus: 0,
        speciality: 'string',
        classification: 'string',
        memberShip: `${e.memberShip}`,
      });
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <>
      <Formik onSubmit={onSubmit} validateOnBlur={false} validateOnChange={false} initialValues={data.data[0]}>
        {({ values, setFieldValue, errors }) => {
          return (
            <Form>
              <Modal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                // onSubmit={onSubmit}
                title={`موافقة على الطلب`}
                isLoading={mutation.isLoading}
                add={true}
              >
                {/* Submit Form */}

                <label className={`flex  flex-col ${dir('justify-start', 'justify-end')}  space-y-2`}>
                  <span className={`font-bold text-base ${dir('text-right', 'text-right')}`}>رقم العضوية</span>
                  <Field name="memberShip" className="border rounded py-2 px-3" type="number" />
                </label>
              </Modal>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export const editUserMembership = async (e) => {
  console.log('e', e);
  const { data } = await axios.post(`/UserAccount/EditUser`, e);
  return data;
};

export const addNotification = async (e) => {
  console.log('e', e);
  const { data } = await axios.post(`/Notifications/Add`, e);
  return data;
};
